import { AppRouteNames } from "@/shared/@types/AppRouteNames";
import { ThgQuoteDeadlineStatus } from "@/shared/@types/ThqQuoteDeadlineStatus";
import { isAuthenticated } from "@/shared/auth/isAuthenticated.helper";
import { getThgQuoteDeadlineStatus } from "@/shared/helper/thgQuoteDeadlineStatus.helper";

const RegistrationView = () =>
  import("@/app/thg-quote/unauthenticated-vehicle-registration/VehicleRegistrationView/VehicleRegistrationView.vue");
const VehicleRegistrationView = () =>
  import("@/app/thg-quote/vehicle-registration/VehicleRegistrationView/VehicleRegistrationView.vue");
const VehicleApplicationsView = () =>
  import("@/app/thg-quote/vehicle-applications/VehicleApplicationsView/VehicleApplicationsView.vue");
const PageNotFoundView = () =>
  import("@/shared/views/PageNotFoundView/PageNotFoundView.vue");

export const routes = [
  {
    path: "",
    redirect: { name: AppRouteNames.ThgQuoteVehicleApplications },
  },
  {
    path: AppRouteNames.ThgQuoteVehicleApplications,
    name: AppRouteNames.ThgQuoteVehicleApplications,
    component: VehicleApplicationsView,
  },
  {
    path: "registration",
    name: AppRouteNames.ThgQuoteUnauthenticatedVehicleRegistration,
    component: RegistrationView,
    // Redirect to vehicle application overview if user is logged in
    beforeEnter: async () => {
      const userIsAuthenticated = await isAuthenticated();
      if (userIsAuthenticated)
        return {
          name: AppRouteNames.ThgQuoteVehicleApplications,
        };

      return true;
    },
  },
  {
    path: "vehicle-registration",
    name: AppRouteNames.ThgQuoteVehicleRegistration,
    component: VehicleRegistrationView,
    beforeEnter: () => {
      const isRegistrationClosed =
        getThgQuoteDeadlineStatus() === ThgQuoteDeadlineStatus.closed;
      if (isRegistrationClosed)
        return {
          name: AppRouteNames.ThgQuoteVehicleApplications,
        };

      return true;
    },
  },
  {
    path: `:pathMatch(.*)*`,
    component: PageNotFoundView,
    props: {
      homeRouteName: AppRouteNames.ThgQuoteOverview,
    },
  },
];
